import { createSlice } from '@reduxjs/toolkit';
import { fetchBrandingConfig } from './thunk';

interface BrandingConfigurationState {
  config: any | null;
  loading: boolean;
  error: string | null;
}

const initialState: BrandingConfigurationState = {
  config: null,
  loading: false,
  error: null,
};

const brandingConfigurationSlice = createSlice({
  name: 'BrandingConfiguration',
  initialState,
  reducers: {
    setConfig: (state, action) => {
      state.config = action.payload;
      state.loading = false;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBrandingConfig.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBrandingConfig.fulfilled, (state, action) => {
        state.config = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchBrandingConfig.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { setConfig, setLoading, setError } = brandingConfigurationSlice.actions;
export default brandingConfigurationSlice.reducer;